import React from 'react'

const About = () => {
    return (
        <div className="container mt-3">
            <h1>About This App</h1>
            <p>App to search Github users</p>
            <p className="text-muted">Version: 1.0.0</p>
        </div>
    )
}

export default About
